"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapListRecordsInViewport = void 0;
var KeyedCollection_1 = require("../helpers/KeyedCollection");
var MapListRecordItem_1 = require("./MapListRecordItem");
var olExtent = require("ol/extent");
var LoadingState;
(function (LoadingState) {
    LoadingState[LoadingState["NotSet"] = 0] = "NotSet";
    LoadingState[LoadingState["Loading"] = 1] = "Loading";
    LoadingState[LoadingState["Loaded"] = 2] = "Loaded";
})(LoadingState || (LoadingState = {}));
var MapListRecordsInViewport = /** @class */ (function () {
    function MapListRecordsInViewport(_map, _mapStore, _styleFactory, _vectorLayerGroups, _mappingTextPack, _maxZoomLevel, _mapListRecordItem, _elementId) {
        var _this = this;
        if (_maxZoomLevel === void 0) { _maxZoomLevel = null; }
        if (_mapListRecordItem === void 0) { _mapListRecordItem = null; }
        if (_elementId === void 0) { _elementId = "placeholder-listRecordsInViewport"; }
        this._map = _map;
        this._mapStore = _mapStore;
        this._styleFactory = _styleFactory;
        this._vectorLayerGroups = _vectorLayerGroups;
        this._mappingTextPack = _mappingTextPack;
        this._maxZoomLevel = _maxZoomLevel;
        this._mapListRecordItem = _mapListRecordItem;
        this._elementId = _elementId;
        this._currentGroup = null;
        this._selectedFeatures = null;
        this.init = function () {
            _this._element = $("#" + _this._elementId);
            _this._selectedFeatures = new Array();
            _this.initHtml();
            _this.addMapHandlers();
            _this.addRecordListHandlers();
            if (_this._mapListRecordItem === null) {
                _this._mapListRecordItem = new MapListRecordItem_1.MapListRecordItem(_this._mappingTextPack);
            }
        };
        this.initHtml = function () {
            var self = _this;
            var html = "\n        <div class=\"btn-group\">\n            <button class=\"btn btn-light btn-sm dropdown-toggle\" type=\"button\" data-bs-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n                <span class=\"selection\">Show records for </span><span class=\"caret\"></span>\n            </button>\n            <ul id=\"mapRecordList\" class=\"dropdown-menu\"></ul>    \n        </div>\n        <div id=\"mapRecordList-group\" style=\"margin-top:6px\">\n            <ul class=\"mapRecordList\"></ul>\n        </div>";
            self._element.append(html);
            self._elementMapRecordList = $("#mapRecordList-group .mapRecordList");
            self._elementLayerGroupDrodown = $("#mapRecordList");
            //add a radio button for each layer group
            self._vectorLayerGroups.forEach(function (lg) {
                if (lg.displayInLayerSwitcher === true) {
                    self._elementLayerGroupDrodown.append($('<li/>')
                        .append($('<a/>')
                        .append($('<label class="radio-inline control-label">')
                        .append($('<input />', {
                        'id': 'rd' + lg.ref,
                        'type': 'radio',
                        'name': 'mapRecordListLayer',
                        'data': {
                            layergroup: lg.ref,
                            displayName: lg.displayName
                        }
                    })).append(lg.displayName))));
                }
            });
        };
        this.addMapHandlers = function () {
            var self = _this;
            self._map.onLayerVisibilityChanged.subscribe(_this.onOverlayChanged);
            self._map.onLayerLoaded.subscribe(_this.onLayerLoaded);
            self._map.onLayerLoading.subscribe(_this.onLayerLoading);
            self._map.olMap.on('moveend', _this.onMapMoveEnd);
        };
        this.onMapMoveEnd = function (e) {
            if (_this._currentGroup !== null) {
                _this.mapMoveEnd();
            }
        };
        this.onLayerLoading = function (args) {
            //console.log(`MapListRecordsInViewport onLayerLoading: ${args.layer.layerName}`);
            if (_this.isCurrentGroup(args.layer.group.ref)) {
                _this.layerLoading(args.layer);
            }
        };
        this.onLayerLoaded = function (args) {
            //console.log(`MapListRecordsInViewport onLayerLoaded: ${args.layer.layerName}`);   
            if (_this.isCurrentGroup(args.layer.group.ref)) {
                _this.layerLoaded(args.layer);
            }
        };
        this.onOverlayChanged = function (args) {
            //console.log(`MapListRecordsInViewport onOverlayChanged: ${args.layerGroupRef}:${args.visible}`);
            _this.layerGroupVisibiltyChanged(args.layerGroupRef, args.visible);
        };
        this.addRecordListHandlers = function () {
            var self = _this;
            //set the inital button values
            self.setRecordListRadioButtonState();
            $("input[name='mapRecordListLayer']").on('change', function (event) {
                var groupRef = $(this).data('layergroup');
                //set the display name
                $(this).closest(".btn-group").find('.selection').text($(this).data('displayName') + '  ');
                //make sure the dropdown is closed
                $(this).closest(".btn-group").removeClass("open");
                self.setGroupRecord(groupRef);
            });
        };
        this.setGroupRecord = function (groupRef) {
            var self = _this;
            if (self._currentGroup !== null) {
                self._currentGroup.clear();
                self._currentGroup = null;
            }
            self._vectorLayerGroups.forEach(function (g) {
                if (g.ref === groupRef) {
                    self._currentGroup = new GroupRecord(g, self._elementMapRecordList, self._mapListRecordItem);
                }
            });
            self.buildInfoList();
        };
        this.setRecordListRadioButtonState = function (groupRef, visible) {
            if (groupRef === void 0) { groupRef = null; }
            if (visible === void 0) { visible = true; }
            var self = _this;
            for (var _i = 0, _a = _this._vectorLayerGroups; _i < _a.length; _i++) {
                var lg = _a[_i];
                if (groupRef === null || lg.ref === groupRef) {
                    var disabled = !((groupRef === null) ? lg.isVisible(_this._mapStore) : visible);
                    //set the label and input disabled
                    var inputId = "#rd" + lg.ref;
                    //set disable input
                    $(inputId).prop("disabled", disabled);
                    if (disabled === true) {
                        $(inputId).prop("checked", false);
                    }
                    //set disable parent label
                    if (disabled === true) {
                        $(inputId).parent().addClass("disabled");
                    }
                    else {
                        $(inputId).parent().removeClass("disabled");
                    }
                    if (disabled === true && self.isCurrentGroup(lg.ref)) {
                        self._elementLayerGroupDrodown.closest(".btn-group").find('.selection').text('Show records for ');
                    }
                }
            }
        };
        this.isCurrentGroup = function (groupRef) {
            return (_this._currentGroup && _this._currentGroup.ref === groupRef);
        };
        this.layerLoading = function (layer) {
            _this._currentGroup.setLoading(layer);
        };
        this.layerLoaded = function (layer) {
            var self = _this;
            self._currentGroup.setLoaded(layer);
            if (self._currentGroup.allLayersLoaded) {
                self.reBuildList(layer);
            }
        };
        this.layerGroupVisibiltyChanged = function (groupRef, visible) {
            var self = _this;
            self.setRecordListRadioButtonState(groupRef, visible);
            if (self.isCurrentGroup(groupRef)) {
                if (!visible) {
                    //the currently selected group has been turned off
                    self._currentGroup.clear();
                    self._currentGroup = null;
                    return;
                }
                if (visible) {
                    self._currentGroup.layers.GetArray().forEach(function (l) {
                        if (l.loadingState != LoadingState.Loading && l.layer.visible) {
                            self.reBuildList(l.layer);
                        }
                    });
                }
            }
        };
        this.mapMoveEnd = function () {
            var self = _this;
            if (self._currentGroup !== null) {
                self._currentGroup.layers.GetArray().forEach(function (l) {
                    if (l.loadingState != LoadingState.Loading && l.layer.visible) {
                        //console.log(`MapListRecordsInViewport mapMoveEnd populate: ${l.layer.layerName}`);
                        self.reBuildList(l.layer);
                    }
                    else if (!l.layer.visible) {
                        self.reBuildList(l.layer);
                    }
                });
            }
        };
        this.buildInfoList = function () {
            var self = _this;
            var group = self._currentGroup;
            if (!self._currentGroup) {
                //no currently selected layer group
                return;
            }
            self._currentGroup.clear();
            var features = group.getFeatures(self.getMapExtent());
            var uids = features.Keys();
            for (var i = 0, len = uids.length; i < len; i++) {
                var f = features.Item(uids[i])[0];
                var fp = self.getRecordTypeFeatureInfo(f, self._currentGroup.layerGroup);
                fp.data.id = f.getId();
                group.addItem(fp);
            }
            $(".showOnMap").on("click", function () {
                var id = $(this).data("id");
                self.moveMapToFeature(id);
            });
        };
        this.reBuildList = function (layer) {
            if (_this._currentGroup.ref === layer.group.ref) {
                _this.buildInfoList();
            }
        };
        this.getRecordTypeFeatureInfo = function (feature, layerGroup) {
            var p = feature.getProperties();
            return {
                id: feature.getId(),
                uid: p.uid,
                ref: p.ref,
                name: p.name,
                recordType: p.rectype,
                recordSubType: p.recsubtype,
                recordSubTypeCode: p.recsubtypecode,
                data: p,
                heading: "",
                layerGroup: layerGroup
            };
        };
        this.getMapExtent = function () {
            return _this._map.olMap.getView().calculateExtent(_this._map.olMap.getSize());
        };
        this.getZoomForExtent = function (extent) {
            var self = _this;
            var res = self._map.olMap.getView().getResolutionForExtent(extent, self._map.olMap.getSize());
            var z = self._map.olMap.getView().getZoomForResolution(res);
            return Math.min(z, 16);
        };
        this.moveMapToFeature = function (id) {
            var self = _this;
            var dataBounds = olExtent.createEmpty();
            var moveToFeatures = null;
            var featuresColl = self._currentGroup.getFeatures(self.getMapExtent()).GetArray();
            var find = function () {
                var val = new Array();
                featuresColl.forEach(function (f1) {
                    f1.forEach(function (f2) {
                        if (f2.getProperties().uid === id) {
                            val.push(f2);
                        }
                    });
                });
                return val;
            };
            moveToFeatures = find();
            //reset style on currently selected features
            self._selectedFeatures.forEach(function (sf) {
                sf.resetStyle();
            });
            self._selectedFeatures = new Array();
            moveToFeatures.forEach(function (f) {
                self._selectedFeatures.push(new SelectedFeature(f, f.getStyle()));
                f.setStyle(_this._styleFactory.getSelectedStyle(self._currentGroup.layerGroup.layerType, self._currentGroup.layerGroup.layerSubType));
                dataBounds = olExtent.extend(dataBounds, f.getGeometry().getExtent());
            });
            var opts = {
                duration: 1000
            };
            if (_this._maxZoomLevel) {
                opts.maxZoom = _this._maxZoomLevel;
            }
            self._map.olMap.getView().fit(dataBounds, opts);
        };
        this.init();
    }
    return MapListRecordsInViewport;
}());
exports.MapListRecordsInViewport = MapListRecordsInViewport;
var SelectedFeature = /** @class */ (function () {
    function SelectedFeature(feature, style) {
        var _this = this;
        this.feature = feature;
        this.style = style;
        this.resetStyle = function () {
            _this.feature.setStyle(_this.style);
        };
    }
    return SelectedFeature;
}());
var LayerRecord = /** @class */ (function () {
    function LayerRecord(layer) {
        var _this = this;
        this.layer = layer;
        this.loadingState = LoadingState.NotSet;
        this.getFeatures = function (extent) {
            return _this.layerSource.source.getFeaturesInExtent(extent);
        };
        this.layerSource = layer.source;
    }
    return LayerRecord;
}());
var GroupRecord = /** @class */ (function () {
    function GroupRecord(layerGroup, element, mapListRecordItemLink) {
        var _this = this;
        this.layerGroup = layerGroup;
        this.element = element;
        this.mapListRecordItemLink = mapListRecordItemLink;
        this.setLoading = function (layer) {
            _this._loadingCount++;
            _this.setState(layer, LoadingState.Loading);
        };
        this.setLoaded = function (layer) {
            _this._loadingCount++;
            _this.setState(layer, LoadingState.Loaded);
        };
        this.allLayersLoaded = function () {
            return _this._loadingCount === 0;
        };
        this.clear = function () {
            _this.element.empty();
        };
        this.getFeatures = function (extent) {
            var self = _this;
            var featureCollection = new KeyedCollection_1.KeyedCollection();
            self.layers.GetArray().forEach(function (layer) {
                layer.getFeatures(extent).forEach(function (f) {
                    var uid = f.getProperties().uid;
                    var item = featureCollection.Item(uid);
                    if (!item) {
                        item = featureCollection.Add(uid, []);
                    }
                    item.push(f);
                });
            });
            return featureCollection;
        };
        this.addItem = function (feature) {
            var html = _this.mapListRecordItemLink.getHtml(feature);
            html = _this.replaceTokens(html, feature.data);
            _this.element.append(html);
        };
        this.setState = function (layer, state) {
            _this.layers.Item(layer.layerName).loadingState = state;
        };
        this.replaceTokens = function (html, data) {
            //go thru html string and replace any tokens with attribute values
            for (var attributeName in data) {
                if (data.hasOwnProperty(attributeName)) {
                    html = html.replace(new RegExp("\\[" + attributeName + "\\]", "g"), data[attributeName]);
                }
            }
            return html;
        };
        var self = this;
        self.layers = new KeyedCollection_1.KeyedCollection();
        self._loadingCount = 0;
        layerGroup.layers.forEach(function (l) {
            self.layers.Add(l.layerName, new LayerRecord(l));
        });
    }
    Object.defineProperty(GroupRecord.prototype, "ref", {
        get: function () {
            return this.layerGroup.ref;
        },
        enumerable: false,
        configurable: true
    });
    return GroupRecord;
}());
//# sourceMappingURL=MapListRecordsInViewport.js.map